<mat-card *ngIf="items && items.buchungen.length">
  <mat-card-header>
    <mat-card-title>Kosten der Reisen</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <table class="table">
      <tr>
        <th>Reise</th>
        <th *ngIf="items.mehrereTeilnehmer">Teilnehmer</th>
        <th>Kategorie</th>
        <th style="text-align:right" *ngIf="items.sonderpreis">Sonderp.</th>
        <th>Kurtaxe</th>
        <th>Sorgenfrei-Tarif</th>
        <th style="text-align:right">Bezahlt</th>
        <th style="text-align:right">Jetzt Fällig</th>
        <th style="text-align:right">Insg. Offen</th>
        <th>Hinweis</th>
      </tr>
      <tr *ngFor="let item of items.buchungen">
        <td>{{item.reise.dateString}} {{item.reise.name}}</td>
        <td *ngIf="items.mehrereTeilnehmer">{{item.teilnehmer.name()}}</td>
        <td>{{item.kategorie | namePreis}}</td>
        <td style="text-align:right" *ngIf="items.sonderpreis">{{item.sonderpreis | preis}}</td>
        <td style="text-align:right">{{item.kurtaxe | preis}}</td>
        <td style="text-align:right">{{item.sorgenfreiTarif | preis}}</td>
        <td style="text-align:right">{{item.gesamtBezahlt | preis}}</td>
        <td style="text-align:right">{{item.faelligerBetrag | preis}}</td>
        <td style="text-align:right">{{item.offenerBetrag | preis}}</td>
        <td>{{item.zahlungHinweisText}}</td>
      </tr>
      <tr>
        <th [colSpan]="4 + items.mehrereTeilnehmer + items.sonderpreis">Gesamt</th>
        <th style="text-align:right">{{items.gesamtBezahlt | preis}}</th>
        <th style="text-align:right">{{items.faelligerBetrag | preis}}</th>
        <th style="text-align:right">{{items.offenerBetrag | preis}}</th>
        <th></th>
      </tr>
      <tr *ngIf="user.guthaben > 0">
        <th [colSpan]="4 + items.mehrereTeilnehmer + items.sonderpreis">inkl Guthaben {{user.guthaben | preis}}</th>
        <th style="text-align:right">{{items.gesamtBezahlt + user.guthaben | preis}}</th>
        <th style="text-align:right">{{items.faelligerBetrag - user.guthaben | preis}}</th>
        <th style="text-align:right">{{items.offenerBetrag  - user.guthaben | preis}}</th>
        <th></th>
      </tr>
    </table>
    <ng-container *ngIf="!admin">
      <div class="alert alert-info">{{service.texte.hinweisZahlung()}}</div>
    </ng-container>
  </mat-card-content>
</mat-card>
